module.exports = __webpack_public_path__ + "img/erase_0.1459a503.png";